import Action from '../../../decorators/Action';
import Observable from '../../../decorators/Observable';
import StoreFieldInSession from '../../../decorators/StoreFieldInSession';
import AbstractSessionModel from '../../../models/AbstractSessionModel';
import { SiteElementData } from '../services/PageBuilderDataCollector';

class PageElementsDataModel extends AbstractSessionModel {
  @StoreFieldInSession({
    type: 'Map'
  })
  @Observable()
  public pageElements: Map<
    string | number /*this is the id of the page */,
    SiteElementData[]
  > = new Map();

  @StoreFieldInSession({
    type: 'Map'
  })
  @Observable()
  public templateElements: Map<
    number /*this is the id of the template */,
    SiteElementData[]
  > = new Map();

  constructor() {
    super();
    super.initFields();
  }

  @Action()
  public pushPageElement(pageId, element: SiteElementData): void {
    if (this.pageElements.has(pageId)) {
      this.pageElements.get(pageId).push(element);
    } else {
      this.pageElements.set(pageId, [element]);
    }
  }

  @Action()
  public pushTemplateElement(templateId, element: SiteElementData): void {
    if (this.templateElements.has(templateId)) {
      this.templateElements.get(templateId).push(element);
    } else {
      this.templateElements.set(templateId, [element]);
    }
  }

  getSessionKey(): string {
    return 'PageElementsDataModel';
  }
}

export default new PageElementsDataModel();
